import { carouselItems } from '@/mocks/homeData';

const carouselImages = [
  'https://readdy.ai/api/search-image?query=Romantic%20period%20drama%20scene%20with%20couple%20silhouetted%20against%20sunset%20over%20ancient%20Chinese%20garden%2C%20warm%20golden%20and%20rose%20tones%2C%20poetic%20atmosphere%2C%20cinematic%20widescreen%20composition%2C%20ethereal%20and%20dreamy&width=1200&height=600&seq=carousel-01&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Intense%20modern%20courtroom%20drama%20with%20dramatic%20overhead%20lighting%2C%20tension%20filled%20atmosphere%2C%20professional%20setting%20with%20warm%20wood%20tones%2C%20cinematic%20composition%2C%20sophisticated%20color%20grading&width=1200&height=600&seq=carousel-02&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Magical%20fantasy%20world%20with%20floating%20luminous%20elements%20against%20deep%20teal%20night%20sky%2C%20warm%20glowing%20particles%2C%20wonder%20and%20adventure%20mood%2C%20cinematic%20fantasy%20aesthetic%2C%20rich%20atmospheric%20colors&width=1200&height=600&seq=carousel-03&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Gritty%20urban%20street%20at%20night%20with%20neon%20reflections%20on%20wet%20pavement%2C%20lone%20figure%20walking%2C%20moody%20and%20atmospheric%2C%20film%20grain%20texture%2C%20warm%20amber%20street%20lights%20contrasting%20cool%20shadows&width=1200&height=600&seq=carousel-04&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Warm%20family%20gathering%20around%20dinner%20table%20in%20cozy%20traditional%20home%2C%20soft%20overhead%20lighting%2C%20genuine%20emotional%20moment%2C%20lived%20in%20atmosphere%2C%20rich%20warm%20tones%2C%20cinematic%20natural%20light&width=1200&height=600&seq=carousel-05&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Futuristic%20cityscape%20with%20flying%20vehicles%20and%20holographic%20displays%2C%20warm%20sunset%20colors%20bleeding%20into%20cool%20highlights%2C%20grand%20scale%2C%20cinematic%20sci%20fi%20aesthetic%2C%20breathtaking%20detail&width=1200&height=600&seq=carousel-06&orientation=landscape',
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-50 scroll-mt-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading text-foreground-900 mb-3">
              本周焦点
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
              编辑部精选，一周不可错过的精彩剧集
            </p>
          </div>

          <div className="flex flex-col gap-6 md:gap-8">
            {carouselItems.map((item, index) => (
              <div
                key={item.title}
                className={`group flex flex-col ${
                  index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
                } gap-5 md:gap-8 bg-background-100 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer`}
              >
                <div className="lg:w-1/2 relative overflow-hidden bg-background-200">
                  <div className="aspect-[2/1] lg:aspect-auto lg:h-full">
                    <img
                      src={carouselImages[index]}
                      alt={`${item.title} - ${item.subtitle}`}
                      title={`${item.title} - ${item.subtitle}`}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                </div>
                <div className="lg:w-1/2 flex flex-col justify-center p-5 md:p-8">
                  <span className="inline-block self-start px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3 whitespace-nowrap">
                    {item.tag}
                  </span>
                  <h3 className="text-lg md:text-2xl font-heading text-foreground-900 mb-2">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-400 mb-3">
                    {item.subtitle}
                  </p>
                  <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                    {item.description}
                  </p>
                  <span className="inline-flex items-center gap-1 mt-4 text-sm text-primary-600 font-medium group-hover:gap-2 transition-all cursor-pointer">
                    查看详情
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}